"use strict";
export default {
  baseJumpUrl: "https://bdplapi.meiyeyanjiu.com/index.php?s=/api/",
};
